import { ESTADOS_EN_AUTORIZACION, etiquetaEstado } from "@/lib/estado-labels";
import type { MiSolicitud } from "@/lib/types";

/**
 * Filtro de la columna Estado de «Mis solicitudes» · lista desplegable con valores EXACTOS
 * (los mismos que entiende el backend · `ListarMisSolicitudesHandler.FiltrarEstado`):
 * `autorizacion` (cualquier nivel), `autorizacion:N` (esperando el nivel N),
 * `autorizacion:mesa` (esperando a Mesa de Control) o el nombre del estado.
 */
const NIVELES_FILTRO = [1, 2, 3, 4];

/** Estados fuera de autorización, en el orden del ciclo de vida. */
const ESTADOS_FILTRO = [
  "Iniciada",
  "TipoSeleccionado",
  "SubtipoSeleccionado",
  "ContratoAnualizadoSeleccionado",
  "OrdenDeCompraSeleccionada",
  "CfdiPendiente",
  "CfdiCargado",
  "EnValidacionReglas",
  "ReglasRechazadas",
  "EnValidacionFiscal",
  "Validado",
  "RechazadoFiscal",
  "SuspendidaFiscal",
  "CapturandoDatos",
  "SeleccionandoProveedor",
  "Prorrateando",
  "ProvisionalmenteListo",
  "AdjuntandoDocumentos",
  "ListoParaAutorizacion",
  "EnRevisionDocumental",
  "RechazadaParaCorreccion",
  "Autorizada",
  "DadaDeBajaPorAutorizador",
  "CanceladaPorSolicitante",
  "DescartadaPorPlazoVencido",
];

export const OPCIONES_FILTRO_ESTADO: { value: string; label: string }[] = [
  { value: "autorizacion", label: "En autorización · todos los niveles" },
  ...NIVELES_FILTRO.map((n) => ({ value: `autorizacion:${n}`, label: `En autorización · nivel ${n}` })),
  { value: "autorizacion:mesa", label: "En autorización · Mesa de Control" },
  ...ESTADOS_FILTRO.map((e) => ({ value: e, label: etiquetaEstado(e) })),
];

/** Etiqueta legible de un valor del filtro (para el chip); el valor tal cual si no es de la lista. */
export function etiquetaFiltroEstado(valor: string): string {
  return OPCIONES_FILTRO_ESTADO.find((o) => o.value === valor)?.label ?? valor;
}

/** ¿La solicitud cumple el filtro de estado? (espejo de `FiltrarEstado` del backend). */
export function coincideFiltroEstado(it: MiSolicitud, valor: string): boolean {
  const v = valor.trim();
  if (!v) return true;
  if (v.toLowerCase().startsWith("autorizacion")) {
    if (!ESTADOS_EN_AUTORIZACION.has(it.estado)) return false;
    const resto = v.slice("autorizacion".length).replace(/^:/, "");
    if (!resto) return true;
    if (resto.toLowerCase() === "mesa") return (it.flujoRolActual ?? "").includes("MesaDeControl");
    if (/^\d+$/.test(resto)) return it.flujoNivelActual === Number(resto);
  }
  if (ESTADOS_FILTRO.includes(v)) return it.estado === v;
  return etiquetaEstado(it.estado).toLowerCase().includes(v.toLowerCase());
}
